export default __webpack_public_path__ + "static/media/c001-Picture2.732cde85.jpg";